export const tr = {
    'campaign-group': 'Kampanya/grup',
    'campaign-type': 'Kampanya türü',
    name: 'Ad',
    'price-context': 'Bin gösterim başına teklif, {currency}',
    'price-context-networks': 'Teklif (ağlarda), {currency}',
    'user-profile-condition': 'Gösterim koşulları'
};
